/* COMPRE E GANHE v12 - BPM Theme */
;(function(){

/* =========================================================
   CONFIG
   ========================================================= */
function lerConfig(){
  var el=document.getElementById('ceg-section-config');
  if(!el)return null;
  try{
    var sc=JSON.parse(el.textContent);
    if(!sc||!sc.ativo)return null;

    var rules={};
    var valorRules=[];

    (sc.regras||[]).forEach(function(r){
      if(r.tipo==='valor'){
        if(r.valor_minimo&&r.brindes&&r.brindes.length)
          valorRules.push({valor_minimo:r.valor_minimo,brindes:r.brindes});
        return;
      }
      if(!r.produto_elegivel)return;
      if(r.brindes&&r.brindes.length)   rules[r.produto_elegivel]=r.brindes;
      else if(r.produto_brinde)          rules[r.produto_elegivel]=r.produto_brinde;
    });

    valorRules.sort(function(a,b){return b.valor_minimo-a.valor_minimo;});

    if(!Object.keys(rules).length&&!valorRules.length){
      console.warn('[CEG] Nenhuma regra configurada. Verifique se produto_brinde_1 esta preenchido em cada regra.');
      return null;
    }

    if(!Object.keys(rules).length&&valorRules.length){
      console.warn('[CEG] Nenhuma regra de produto/colecao ativa. Se configurou regra de colecao, verifique se Brinde 1 esta preenchido.');
    }

    var t=sc.textos||{};
    return{
      rules:rules,
      valorRules:valorRules,
      GIFT_PROP:'_gift',
      GIFT_FROM:'_gift_from',
      GIFT_FROM_VALOR:'_gift_from_valor',
      txt:{
        title:       t.titulo         ||'Brinde desbloqueado',
        subtitle:    t.subtitulo      ||'Selecione um item para receber gratuitamente com sua compra',
        btnSelect:   t.btn_selecionar ||'Selecionar brinde',
        btnDecline:  t.btn_recusar    ||'Nao quero brinde',
        confirmTitle:t.confirm_titulo ||'Ue, nao quer brinde?',
        confirmText: t.confirm_texto  ||'E sua chance de completar seu armario.',
        confirmNo:   t.confirm_nao    ||'Tenho certeza, nao quero brinde',
        confirmYes:  t.confirm_sim    ||'Quero brinde sim, cliquei errado'
      }
    };
  }catch(e){console.error('[CEG] Erro config:',e);return null;}
}

/* =========================================================
   ESTADO
   ========================================================= */
var S={
  config:null,
  overlay:null,
  confirm:null,
  isOpen:false,
  isConfirm:false,
  isAdding:false,
  isValorRule:false,
  valorMinimo:null,
  triggerHandle:null,
  brindes:[],
  selectedBrindeHandle:null,
  selectedVariantId:null,
  afterClose:null,
  drawerPendente:false,
  timers:{},
  giftAddedThisSession:false,
  isGiftPopup:false,
  justAddedGift:false
};

/* =========================================================
   UTILITARIOS
   ========================================================= */
function debounce(k,fn,ms){
  clearTimeout(S.timers[k]);
  S.timers[k]=setTimeout(fn,ms);
}
function fmt(cents){
  if(!cents)return'R$ 0,00';
  return'R$ '+(cents/100).toFixed(2).replace('.',',');
}
/* Escapa HTML em dados dinamicos antes de innerHTML (mesmo padrao do
   escHtml de popup-promocional.js / _esc de kit-builder.js). */
function esc(s){
  return String(s==null?'':s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function isGiftPayload(body){
  if(!body)return false;
  try{
    var p=typeof body==='string'?JSON.parse(body):null;
    if(p&&p.properties&&p.properties[S.config.GIFT_PROP]==='true')return true;
  }catch(e){}
  if(typeof FormData!=='undefined'&&body instanceof FormData&&
     body.get('properties['+S.config.GIFT_PROP+']')==='true')return true;
  return false;
}

/* =========================================================
   CHECAR SE JA TEM BRINDE NO CARRINHO
   ========================================================= */
function cartTemBrinde(handle, isValor){
  return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    return (cart.items||[]).some(function(i){
      if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')return false;
      if(isValor) return i.properties[S.config.GIFT_FROM_VALOR]===''+handle;
      return i.properties[S.config.GIFT_FROM]===handle;
    });
  }).catch(function(){return false;});
}

/* =========================================================
   TOTAL DO CARRINHO (ignorando brindes) + CHECAGEM DE REGRA DE VALOR
   Usado sempre que o carrinho muda, inclusive depois de um popup
   de regra por produto ser resolvido — assim o cliente tambem
   e avisado se o carrinho ja bateu o valor minimo.
   ========================================================= */
function verificarRegraValorAtual(){
  if(!S.config.valorRules.length)return;
  /* Não verificar enquanto está abrindo drawer após adicionar brinde */
  if(S.justAddedGift)return;
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var total=0;
    (cart.items||[]).forEach(function(i){
      if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')total+=i.line_price;
    });
    /* Reset flag se carrinho está vazio ou sem itens válidos */
    if(!cart.items||cart.items.length===0||total===0){
      S.giftAddedThisSession=false;
    }
    checarRegrasValorComTotal(total);
  }).catch(function(){});
}

function checarRegrasValorComTotal(total){
  if(!S.config.valorRules.length)return;
  if(S.isOpen||S.isConfirm)return;

  var regra=null;
  for(var i=0;i<S.config.valorRules.length;i++){
    if(total>=S.config.valorRules[i].valor_minimo){
      regra=S.config.valorRules[i];
      break;
    }
  }

  /* Reset flag se carrinho saiu da regra de valor */
  if(!regra){
    S.giftAddedThisSession=false;
    return;
  }

  /* Não reabrir popup se já adicionou brinde nesta sessão */
  if(S.giftAddedThisSession)return;

  cartTemBrinde(regra.valor_minimo,true).then(function(ja){
    if(ja)return;
    abrirPopupValor(regra);
  });
}

/* =========================================================
   REMOVER ORFAOS
   ========================================================= */
function removerOrfaos(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var total=0;
    (cart.items||[]).forEach(function(i){
      if(!i.properties||i.properties[S.config.GIFT_PROP]!=='true')total+=i.line_price;
    });

    (cart.items||[]).forEach(function(gift){
      if(!gift.properties||gift.properties[S.config.GIFT_PROP]!=='true')return;
      var remover=false;

      var from=gift.properties[S.config.GIFT_FROM];
      if(from&&!gift.properties[S.config.GIFT_FROM_VALOR]){
        var presente=(cart.items||[]).some(function(i){
          return i.handle===from&&(!i.properties||i.properties[S.config.GIFT_PROP]!=='true');
        });
        if(!presente)remover=true;
      }

      var fv=gift.properties[S.config.GIFT_FROM_VALOR];
      if(fv&&total<parseInt(fv,10))remover=true;

      if(remover){
        fetch('/cart/change.js',{
          method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:gift.key,quantity:0})
        }).catch(function(e){console.error('[CEG] falha ao remover brinde orfao:',e);});
      }
    });
  }).catch(function(){});
}

/* =========================================================
   ABRIR POPUP — produto/colecao
   ========================================================= */
function abrirPopup(handle,afterFn){
  if(S.isOpen||S.isConfirm)return;
  var regra=S.config.rules[handle];
  if(!regra)return;

  S.isValorRule=false; S.valorMinimo=null;
  S.triggerHandle=handle; S.afterClose=afterFn||null;
  S.selectedBrindeHandle=null; S.selectedVariantId=null;

  if(typeof regra==='string')       S.brindes=[{handle:regra,imagem:null}];
  else if(Array.isArray(regra))     S.brindes=regra;
  else                               S.brindes=[regra];

  _abrirComBrindes();
}

/* =========================================================
   ABRIR POPUP — valor do carrinho
   ========================================================= */
function abrirPopupValor(regra){
  if(S.isOpen||S.isConfirm)return;
  S.isValorRule=true; S.valorMinimo=regra.valor_minimo;
  S.triggerHandle='__valor_'+regra.valor_minimo;
  S.afterClose=null;
  S.selectedBrindeHandle=null; S.selectedVariantId=null;
  S.brindes=regra.brindes;
  _abrirComBrindes();
}

function _abrirComBrindes(){
  S.isGiftPopup=true;
  mostrarOverlay();
  renderSkeleton();
  var promises=S.brindes.map(function(b){
    return fetch('/products/'+b.handle+'.js').then(function(r){return r.json();});
  });
  Promise.all(promises)
    .then(renderBrindes)
    .catch(function(){fecharEProsseguir();});
}

/* =========================================================
   RENDER
   ========================================================= */
function renderSkeleton(){
  var card='<div class="ceg-brinde-card ceg-skeleton-card">'+
    '<div class="ceg-product__image-wrap"><div class="ceg-skeleton" style="position:absolute;inset:0"></div></div>'+
    '<div class="ceg-product__info">'+
    '<div class="ceg-skeleton" style="height:16px;width:75%;margin-bottom:8px"></div>'+
    '<div class="ceg-skeleton" style="height:14px;width:45%;margin-bottom:12px"></div>'+
    '<div class="ceg-skeleton" style="height:36px;width:100%"></div>'+
    '</div></div>';
  document.getElementById('ceg-product-inner').innerHTML=
    '<div class="ceg-brindes-carousel-wrap"><div class="ceg-brindes-track">'+card+card+'</div></div>';
}

function renderBrindes(produtos){
  var disp=produtos.filter(function(p){
    return p.variants&&p.variants.some(function(v){return v.available;});
  });
  if(!disp.length){fecharEProsseguir();return;}

  var isCarousel=disp.length>1;
  var wrapOpen=isCarousel
    ?'<div class="ceg-brindes-carousel-wrap"><div class="ceg-brindes-track" id="ceg-brindes-track">'
    :'<div class="ceg-brindes-grid ceg-brindes-1">';
  var wrapClose=isCarousel?'</div></div>':'</div>';
  var html=wrapOpen;

  disp.forEach(function(product,idx){
    var available=product.variants.filter(function(v){return v.available;});
    var comp=product.compare_at_price_max||product.price;

    var brindeCfg=null;
    for(var bi=0;bi<S.brindes.length;bi++){
      if(S.brindes[bi]&&S.brindes[bi].handle===product.handle){brindeCfg=S.brindes[bi];break;}
    }
    var imgCustom=brindeCfg&&brindeCfg.imagem?brindeCfg.imagem:null;
    var img=imgCustom||product.featured_image||(product.images&&product.images[0])||'';
    var opts=available.map(function(v){return'<option value="'+v.id+'">'+esc(v.title)+'</option>';}).join('');
    var sel=idx===0?'ceg-brinde-card--selected':'';

    html+=
      '<div class="ceg-brinde-card '+sel+'" data-handle="'+product.handle+'" data-idx="'+idx+'">'+
      '<div class="ceg-product__image-wrap">'+
      (img?'<img src="'+esc(img)+'" alt="'+esc(product.title)+'" loading="lazy">':'')+
      '<span class="ceg-product__free-tag">GRATIS</span>'+
      '</div>'+
      '<div class="ceg-product__info">'+
      '<h3 class="ceg-product__title">'+esc(product.title)+'</h3>'+
      '<div class="ceg-product__prices">'+
      '<span class="ceg-product__compare">'+fmt(comp)+'</span>'+
      '<span class="ceg-product__free-price">R$ 0,00</span>'+
      '</div>'+
      '<div class="ceg-variants">'+
      '<span class="ceg-variants__label">Selecione a opcao</span>'+
      '<select class="ceg-variants__select ceg-select-brinde" data-handle="'+product.handle+'" aria-label="Selecione a opcao do brinde">'+opts+'</select>'+
      '</div></div>'+
      (isCarousel?'<div class="ceg-brinde-check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></div>':'')+
      '</div>';
  });
  html+=wrapClose;

  var arrowsHtml='',dotsHtml='';
  if(isCarousel){
    arrowsHtml=
      '<button type="button" class="ceg-carousel-arrow ceg-carousel-arrow--prev" id="ceg-arrow-prev" aria-label="Anterior">'+
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg></button>'+
      '<button type="button" class="ceg-carousel-arrow ceg-carousel-arrow--next" id="ceg-arrow-next" aria-label="Proximo">'+
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg></button>';
    dotsHtml='<div class="ceg-brindes-dots" id="ceg-brindes-dots">'+
      disp.map(function(_,i){return'<span class="ceg-brindes-dot'+(i===0?' ceg-brindes-dot--active':'')+'" data-dot="'+i+'"></span>';}).join('')+
      '</div>';
  }

  document.getElementById('ceg-product-inner').innerHTML=
    (isCarousel?'<div class="ceg-carousel-outer">'+html+arrowsHtml+'</div>':html)+
    dotsHtml+
    '<p class="ceg-variants__error" id="ceg-variant-error">Selecione uma opcao.</p>';

  S.selectedBrindeHandle=disp[0].handle;
  var fs=document.querySelector('.ceg-select-brinde');
  if(fs)S.selectedVariantId=parseInt(fs.value,10);

  document.querySelectorAll('.ceg-brinde-card').forEach(function(card){
    card.addEventListener('click',function(e){
      if(e.target&&e.target.tagName==='SELECT')return;
      selecionarCard(card);
    });
  });
  document.querySelectorAll('.ceg-select-brinde').forEach(function(s){
    s.addEventListener('change',function(e){
      e.stopPropagation();
      var card=s.closest('.ceg-brinde-card');
      if(card)selecionarCard(card);
      S.selectedVariantId=parseInt(s.value,10);
      var er=document.getElementById('ceg-variant-error');
      if(er)er.classList.remove('ceg-show');
    });
  });

  if(isCarousel)initCarousel();
}

/* =========================================================
   CARROSSEL — setas, pontos e scroll-snap
   Funciona igual em mobile e desktop: as setas ficam
   escondidas automaticamente quando o inicio/fim e alcancado.
   ========================================================= */
function scrollCardIntoView(card){
  if(!card||typeof card.scrollIntoView!=='function')return;
  card.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});
}

function initCarousel(){
  var track=document.getElementById('ceg-brindes-track');
  if(!track)return;
  var cards=Array.prototype.slice.call(track.querySelectorAll('.ceg-brinde-card'));
  var dots=Array.prototype.slice.call(document.querySelectorAll('.ceg-brindes-dot'));
  var btnPrev=document.getElementById('ceg-arrow-prev');
  var btnNext=document.getElementById('ceg-arrow-next');

  function indiceAtual(){
    var trackRect=track.getBoundingClientRect();
    var centro=trackRect.left+trackRect.width/2;
    var maisProximo=0,menorDist=Infinity;
    cards.forEach(function(c,i){
      var r=c.getBoundingClientRect();
      var cCentro=r.left+r.width/2;
      var d=Math.abs(cCentro-centro);
      if(d<menorDist){menorDist=d;maisProximo=i;}
    });
    return maisProximo;
  }

  function atualizarUI(){
    var atual=indiceAtual();
    dots.forEach(function(d,i){d.classList.toggle('ceg-brindes-dot--active',i===atual);});

    var folga=4;
    var noInicio=track.scrollLeft<=folga;
    var noFim=track.scrollLeft>=track.scrollWidth-track.clientWidth-folga;
    if(btnPrev)btnPrev.classList.toggle('ceg-carousel-arrow--hidden',noInicio);
    if(btnNext)btnNext.classList.toggle('ceg-carousel-arrow--hidden',noFim);
  }

  var scrollTimer=null;
  track.addEventListener('scroll',function(){
    clearTimeout(scrollTimer);
    scrollTimer=setTimeout(atualizarUI,80);
  },{passive:true});

  dots.forEach(function(dot,i){
    dot.addEventListener('click',function(){scrollCardIntoView(cards[i]);});
  });

  function passo(direcao){
    var card=cards[0];
    var gap=12;
    var delta=(card.getBoundingClientRect().width+gap)*direcao;
    track.scrollBy({left:delta,behavior:'smooth'});
  }
  if(btnPrev)btnPrev.addEventListener('click',function(){passo(-1);});
  if(btnNext)btnNext.addEventListener('click',function(){passo(1);});

  atualizarUI();
}

function selecionarCard(card){
  document.querySelectorAll('.ceg-brinde-card').forEach(function(c){c.classList.remove('ceg-brinde-card--selected');});
  card.classList.add('ceg-brinde-card--selected');
  S.selectedBrindeHandle=card.dataset.handle;
  var s=card.querySelector('.ceg-select-brinde');
  if(s)S.selectedVariantId=parseInt(s.value,10);
  var er=document.getElementById('ceg-variant-error');
  if(er)er.classList.remove('ceg-show');
}

/* =========================================================
   ADICIONAR BRINDE
   ========================================================= */
function selecionarBrinde(){
  if(S.isAdding)return;
  if(!S.selectedVariantId){
    var er=document.getElementById('ceg-variant-error');
    if(er)er.classList.add('ceg-show');
    return;
  }
  S.isAdding=true;
  var btn=document.getElementById('ceg-btn-select');
  if(btn)btn.classList.add('ceg-loading');

  /* Abrir drawer imediatamente ao adicionar brinde */
  try{
    if(typeof theme!=='undefined'&&theme.cart&&theme.cart.drawer&&typeof theme.cart.drawer.openDrawer==='function'){
      theme.cart.drawer.openDrawer();
    }
  }catch(e){}
  S.justAddedGift=true;

  var props={};
  props[S.config.GIFT_PROP]='true';
  if(S.isValorRule) props[S.config.GIFT_FROM_VALOR]=''+S.valorMinimo;
  else              props[S.config.GIFT_FROM]=S.triggerHandle;

  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:S.selectedVariantId,quantity:1,properties:props})
  }).then(function(r){
    if(!r.ok)throw new Error('cart/add falhou');
    return r.json();
  }).then(function(){
    /* Remove loading state do botão */
    if(btn)btn.classList.remove('ceg-loading');
    S.isAdding=false;
    S.giftAddedThisSession=true;
    S.justAddedGift=true;

    /* Recarregar drawer imediatamente para mostrar brinde */
    try{
      if(typeof theme!=='undefined'&&theme.cart&&theme.cart.drawer&&typeof theme.cart.drawer.reloadCart==='function'){
        theme.cart.drawer.reloadCart();
      }
    }catch(e){
      console.error('[CEG] Erro ao recarregar drawer:', e);
    }

    var area=document.getElementById('ceg-product-area');
    if(area)area.innerHTML=
      '<div class="ceg-success">'+
      '<button class="ceg-success-close" id="ceg-success-close" style="position:absolute;top:12px;right:12px;background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;justify-content:center;color:#999;transition:color 0.2s;" title="Fechar">'+
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'+
      '</button>'+
      '<div class="ceg-success__icon">'+
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">'+
      '<polyline points="20 6 9 17 4 12"></polyline></svg></div>'+
      '<h3>Brinde adicionado!</h3>'+
      '<p>Seu brinde foi adicionado ao carrinho gratuitamente.</p>'+
      '</div>';

    /* Botão X para fechar manualmente */
    var closeBtn=document.getElementById('ceg-success-close');
    if(closeBtn){
      closeBtn.addEventListener('click',function(e){
        e.preventDefault();
        fecharEProsseguir();
      });
      closeBtn.addEventListener('mouseenter',function(){this.style.color='#333';});
      closeBtn.addEventListener('mouseleave',function(){this.style.color='#999';});
    }
    var ac=document.querySelector('.ceg-actions');if(ac)ac.style.display='none';
    var cc=document.getElementById('ceg-close');if(cc)cc.style.display='none';

    var noCart=window.location.pathname.indexOf('/cart')>-1;
    setTimeout(function(){
      fecharEProsseguir();
      if(noCart){
        setTimeout(function(){window.location.reload();},400);
      } else {
        /* Drawer já está aberto desde o início, só resetar flag */
        setTimeout(function(){
          S.justAddedGift=false;
        },1000);
      }
    },1800);
  }).catch(function(err){
    console.error('[CEG] Erro brinde:',err);
    if(btn)btn.classList.remove('ceg-loading');
    S.isAdding=false;
  });
}

/* =========================================================
   UI
   ========================================================= */
/* O popup e o drawer do carrinho abrem juntos apos o cart/add: o overlay
   (z-index 9998) cobria o FINALIZAR COMPRA do drawer e engolia o clique.
   Enquanto o popup esta aberto o drawer fica fechado/suprimido; ao fechar
   o popup (qualquer caminho), o drawer abre com o carrinho atualizado. */
function fecharDrawerCarrinho(){
  var d=document.getElementById('ajaxDrawer');
  if(!d||d.classList.contains('d-none'))return false;
  var o=d.querySelector('.ajax-drawer__overlay');
  if(o)o.classList.add('opacity-0');
  var c=d.querySelector('#cartDrawer');
  if(c){c.classList.remove('translate-right-center');c.classList.remove('activated');}
  setTimeout(function(){d.classList.add('d-none');},400);
  document.body.classList.remove('noscroll');
  return true;
}
function abrirDrawerCarrinho(){
  if(window.location.pathname.indexOf('/cart')>-1)return;
  try{
    if(typeof theme!=='undefined'&&theme.cart&&theme.cart.drawer&&document.getElementById('ajaxDrawer')){
      theme.cart.drawer.openDrawer();
    }else{
      var t=document.querySelector('.js-cart-drawer-toggle');
      if(t)t.click();
    }
  }catch(e){}
}
function patchDrawer(n){
  n=n||0;
  if(typeof theme==='undefined'||!theme.cart||!theme.cart.drawer||!theme.cart.drawer.openDrawer){
    if(n<30)setTimeout(function(){patchDrawer(n+1);},200);
    return;
  }
  var orig=theme.cart.drawer.openDrawer;
  theme.cart.drawer.openDrawer=function(){
    if(S.isOpen){S.drawerPendente=true;return;}
    return orig.apply(this,arguments);
  };
}
function mostrarOverlay(){
  S.isOpen=true;
  /* Não fechar drawer ao abrir popup (deixar aberto) */
  /* if(fecharDrawerCarrinho())S.drawerPendente=true; */
  document.body.classList.add('ceg-body-lock');
  S.overlay.classList.remove('ceg-hidden');
  requestAnimationFrame(function(){requestAnimationFrame(function(){S.overlay.classList.add('ceg-visible');});});
}
function fecharEProsseguir(){
  S.overlay.classList.remove('ceg-visible');
  document.body.classList.remove('ceg-body-lock');
  var fn=S.afterClose;
  var pend=S.drawerPendente;
  var isGift=S.isGiftPopup;
  setTimeout(function(){
    S.overlay.classList.add('ceg-hidden');
    resetEstado();
    if(typeof fn==='function')fn();
    /* Não abrir drawer para popups de brinde */
    if(pend&&!isGift)abrirDrawerCarrinho();
  },350);
}
function resetEstado(){
  S.isOpen=false;S.isAdding=false;S.isConfirm=false;
  S.isValorRule=false;S.valorMinimo=null;
  S.triggerHandle=null;S.selectedBrindeHandle=null;
  S.selectedVariantId=null;S.afterClose=null;S.brindes=[];
  S.drawerPendente=false;S.isGiftPopup=false;
  var a=document.querySelector('.ceg-actions');if(a)a.style.display='';
  var c=document.getElementById('ceg-close');if(c)c.style.display='';
  // A tela de sucesso substitui todo o conteudo de #ceg-product-area,
  // destruindo o #ceg-product-inner. Sem recria-lo aqui, o proximo
  // brinde nunca mais renderiza (o popup reabre travado na tela de sucesso).
  var area=document.getElementById('ceg-product-area');
  if(area)area.innerHTML='<div id="ceg-product-inner"></div>';
}
function triggerDecline(){
  if(!S.isOpen)return;
  S.isConfirm=true;
  S.confirm.classList.remove('ceg-hidden');
  requestAnimationFrame(function(){S.confirm.classList.add('ceg-visible');});
}
function confirmarRecusa(){
  S.isConfirm=false;
  S.confirm.classList.remove('ceg-visible');
  setTimeout(function(){S.confirm.classList.add('ceg-hidden');},250);
  fecharEProsseguir();
}
function cancelarRecusa(){
  S.isConfirm=false;
  S.confirm.classList.remove('ceg-visible');
  setTimeout(function(){
    S.confirm.classList.add('ceg-hidden');
    /* Volta ao popup principal */
    if(S.overlay){
      S.overlay.classList.remove('ceg-hidden');
      requestAnimationFrame(function(){S.overlay.classList.add('ceg-visible');});
    }
  },250);
}

function criarPopups(txt){
  document.querySelectorAll('.ceg-overlay,.ceg-confirm-overlay').forEach(function(e){e.remove();});
  document.body.insertAdjacentHTML('beforeend',
    '<div class="ceg-overlay ceg-hidden" id="ceg-overlay" role="dialog" aria-modal="true">'+
    '<div class="ceg-popup">'+
    '<button class="ceg-close-btn" id="ceg-close" aria-label="Fechar">'+
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">'+
    '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>'+
    '<div class="ceg-header">'+
    '<div class="ceg-header__badge">Brinde desbloqueado</div>'+
    '<h2>'+txt.title+'</h2><p>'+txt.subtitle+'</p></div>'+
    '<div class="ceg-product" id="ceg-product-area"><div id="ceg-product-inner"></div></div>'+
    '<div class="ceg-actions">'+
    '<button class="ceg-btn ceg-btn--primary" id="ceg-btn-select">'+
    '<span class="ceg-btn-text">'+txt.btnSelect+'</span>'+
    '<span class="ceg-spinner"></span></button>'+
    '<button class="ceg-btn ceg-btn--ghost" id="ceg-btn-decline">'+txt.btnDecline+'</button>'+
    '</div></div></div>'+
    '<div class="ceg-confirm-overlay ceg-hidden" id="ceg-confirm-overlay" role="dialog" aria-modal="true">'+
    '<div class="ceg-confirm-popup">'+
    '<h3>'+txt.confirmTitle+'</h3><p>'+txt.confirmText+'</p>'+
    '<div class="ceg-confirm-actions">'+
    '<button class="ceg-btn ceg-btn--outline" id="ceg-confirm-no">'+txt.confirmNo+'</button>'+
    '<button class="ceg-btn ceg-btn--primary" id="ceg-confirm-yes">'+txt.confirmYes+'</button>'+
    '</div></div></div>'
  );
  S.overlay=document.getElementById('ceg-overlay');
  S.confirm=document.getElementById('ceg-confirm-overlay');
  S.overlay.addEventListener('click',function(e){if(e.target===S.overlay)triggerDecline();});
  document.getElementById('ceg-close').addEventListener('click',triggerDecline);
  document.getElementById('ceg-btn-select').addEventListener('click',selecionarBrinde);
  document.getElementById('ceg-btn-decline').addEventListener('click',triggerDecline);
  document.getElementById('ceg-confirm-no').addEventListener('click',confirmarRecusa);
  document.getElementById('ceg-confirm-yes').addEventListener('click',cancelarRecusa);
  document.addEventListener('keydown',function(e){
    if(e.key!=='Escape')return;
    if(S.isConfirm)cancelarRecusa();
    else if(S.isOpen)triggerDecline();
  });
}

/* =========================================================
   URL HELPERS
   ========================================================= */
function isCartAddUrl(url){
  return /\/cart\/add(\.js)?(\?|$)/.test(url);
}
function isCartChangeUrl(url){
  return /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
}

/* =========================================================
   PATCH FETCH
   ========================================================= */
var _lastClickedBtn=null;

function patchTema(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.product-form__submit');
    if(btn)_lastClickedBtn=btn;
  },true);

  var origFetch=window.fetch;
  window.fetch=function(input,init){
    var url=typeof input==='string'?input:(input&&input.url||'');

    /* cart/add.js */
    if(isCartAddUrl(url)&&init&&init.method&&init.method.toUpperCase()==='POST'){
      if(isGiftPayload(init.body))return origFetch.apply(this,arguments);

      var isBuyNow=_lastClickedBtn&&_lastClickedBtn.classList.contains('buy-now');
      _lastClickedBtn=null;

      return origFetch.apply(this,arguments).then(function(resp){
        if(!resp.ok)return resp;
        resp.clone().json().then(function(data){
          if(data.status)return;

          var items=Array.isArray(data.items)?data.items:data.handle?[data]:[];

          // --- Regra por produto/colecao ---
          var handle=null;
          for(var i=0;i<items.length;i++){
            var it=items[i];
            if(!it||!it.handle)continue;
            if(it.properties&&it.properties[S.config.GIFT_PROP]==='true')continue;
            if(S.config.rules[it.handle]){handle=it.handle;break;}
          }
          if(handle){
            if(isBuyNow){
              try{sessionStorage.setItem('ceg_pending',handle);}catch(e){}
              try{sessionStorage.setItem('ceg_pending_valor','1');}catch(e){}
            } else {
              // Mesmo quando ja tem o brinde do produto, ainda verifica a regra
              // de valor — o carrinho pode ja ter atingido o minimo tambem.
              cartTemBrinde(handle,false).then(function(ja){
                if(!ja) abrirPopup(handle,verificarRegraValorAtual);
                else    verificarRegraValorAtual();
              });
            }
            return;
          }

          // --- Regra por valor ---
          if(!S.config.valorRules.length)return;

          if(isBuyNow){
            try{sessionStorage.setItem('ceg_pending_valor','1');}catch(e){}
            return;
          }

          verificarRegraValorAtual();

        }).catch(function(){});
        return resp;
      });
    }

    /* cart/change + cart/update: remove orfaos */
    if(isCartChangeUrl(url)&&
       init&&init.method&&init.method.toUpperCase()==='POST'){
      return origFetch.apply(this,arguments).then(function(r){
        debounce('orfaos',removerOrfaos,400);
        verificarRegraValorAtual();
        return r;
      });
    }

    return origFetch.apply(this,arguments);
  };
}

/* =========================================================
   BUY NOW PENDENTE
   ========================================================= */
function verificarPendenciaCarrinho(){
  if(window.location.pathname.indexOf('/cart')===-1)return;
  try{
    var handle=sessionStorage.getItem('ceg_pending');
    var pendValor=sessionStorage.getItem('ceg_pending_valor');
    if(!handle&&!pendValor)return;

    sessionStorage.removeItem('ceg_pending');
    sessionStorage.removeItem('ceg_pending_valor');

    function tentarAbrir(n){
      n=n||0;
      if(!S.config){
        var cfg=lerConfig();
        if(cfg){S.config=cfg;criarPopups(cfg.txt);}
        else{if(n<20)setTimeout(function(){tentarAbrir(n+1);},200);return;}
      }

      if(handle&&S.config.rules[handle]){
        cartTemBrinde(handle,false).then(function(ja){
          if(ja){ if(pendValor)verificarRegraValorAtual(); return; }
          abrirPopup(handle,function(){
            if(pendValor) verificarRegraValorAtual();
          });
        });
        return;
      }

      if(pendValor) verificarRegraValorAtual();
    }

    setTimeout(function(){tentarAbrir(0);},600);
  }catch(e){}
}

/* =========================================================
   BOOT
   ========================================================= */
function boot(){
  var config=lerConfig();
  if(!config)return;
  S.config=config;
  criarPopups(config.txt);
  patchTema();
  patchDrawer(0);
  verificarPendenciaCarrinho();

  debounce('orfaos_boot',removerOrfaos,1500);

  ['cart:updated','cart:item-removed','cart:refreshed'].forEach(function(ev){
    document.addEventListener(ev,function(){
      debounce('orfaos',removerOrfaos,400);
      verificarRegraValorAtual();
    });
  });
}

window._cegAbrirPopup=function(h,a){abrirPopup(h,a);};

function tryBoot(n){
  if(!document.getElementById('ceg-section-config')&&(n||0)<30){
    setTimeout(function(){tryBoot((n||0)+1);},100);return;
  }
  boot();
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',function(){tryBoot(0);});
}else{
  tryBoot(0);
}

})();
